/* eslint-disable */

/* eslint-disable camelcase */
import React, {
	createContext,
	useEffect,
	useState,
	useMemo,
	useCallback,
	useContext,
} from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { config } from '~/config';
import { apiLucree, apiTransacao, apiGrupos, apiPGM } from '~/services/api';

import TipoPerfil from '../assets/styles/payloadsRecebimentoExcel/perfilGrupo.json';
import PerfilQD from '../assets/styles/payloadsRecebimentoExcel/perfilQD.json';
import { TokenContext } from './TokenContext';


export const RecebimentosContext = createContext([]);

export function RecebimentosProvider(props) {
	const { children, user } = props;
	const projetos = ['Programa QD'];

	const params = {
		dateInit: moment().format('YYYY-MM-DD'),
		dateEnd: moment().format('YYYY-MM-DD'),
	};

	const [gruposTitularConcatenado, setGruposTitularConcatenado] = useState([]);

	const [recebimentosGeral, setRecebimentosGeral] = useState({
		dados: {},
		lista: [],
		loading: true,
		error: null,
	});

	const [recebimentosCard, setRecebimentosCard] = useState({
		lista: [],
		split: {
			nome_split: '',
			parent: false,
			nome_lojista_pai: '',
			porcentagem: null,
			credito: null,
			em_conta: null,
		},
		loading: true,
		error: null,
	});

	const [splitData, setSplitData] = useState({
		"projeto": null,
		"relacao_split": null,
		"porcentagem": null,
		"credito": null,
		"em_conta": null
	});

	const [recebimentosGrupo, setRecebimentosGrupo] = useState({
		data: [],
		lista: [],
		listaConcatenadaGrupo: [],
		listaGrupoDownload: [],
		loading: true,
		error: null,
	});

	const [totalGrupos, setTotalGrupos] = useState({
		total_bruto: 0,
		total_descontos: 0,
		total_debito: 0,
		total_credito: 0,
		total_parcelado: 0,
		total_liquido: 0,
		total_ajustes: 0,
	});

	const [dadosLojista, setDadosLojista] = useState([]);

	const [loadingRecebimentos, setLoadingRecebimentos] = useState(true);

	const [loaderRecebimentos, setLoaderRecebimentos] = useState(false);

	const [tokenState, setTokenState] = useState('');

	const [filtroTipo, setFiltroTipo] = useState('');

	const [documentoTitular, setDocumentoTitular] = useState('');

	const { autenticacaoV1Token } = useContext(TokenContext);

	let callingSplit = false;

	const getLojista = useCallback(
		// eslint-disable-next-line consistent-return
		async (tokenValue) => {
			try {
				const response = await apiGrupos.get(
					`/api/lojista/${user.dados.lojista_id}`,
					{
						headers: {
							'Content-Type': 'application/json',
							Authorization: tokenValue,
						},
					}
				);

				setDadosLojista(response.data.data[0].grupo_nome);
				return response.data.data;
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log('Os dados do lojista não foram carregados.', error);
			}
		},
		[user.dados.lojista_id]
	);

	const getRecebimentosCard = useCallback(
		async (tokenValue, idTitular) => {
			if (callingSplit) return null;
			callingSplit = true;
			if (tokenState) {
				tokenValue = tokenState;
			}

			setLoadingRecebimentos(true);
			// Mudar local do loading
			setRecebimentosCard({
				lista: [],
				split: {
					nome_split: '',
					parent: false,
					nome_lojista_pai: '',
					porcentagem: null,
					credito: null,
					em_conta: null,
				},
				loading: true,
				error: null,
			});

			try {
				const res = await apiTransacao.get(
					`recebimentos-cliente/${idTitular}/cards?init_date=${moment()
						// `recebimentos-cliente/${user.dados.user_id}/cards?init_date=${moment()
						.add(-4, 'days')
						.format('YYYY-MM-DD')}&end_date=${moment()
							.add(4, 'days')
							.format('YYYY-MM-DD')}`,
					{
						headers: {
							'Content-Type': 'application/json',
							Authorization: tokenValue,
						},
					}
				);

				// mudar o user_id
				const arrayLista = [];

				Object.keys(res.data).forEach((item) => {
					arrayLista.push(res.data[item]);
				});

			
				let splitporcentagem = {
					credito: null,
					em_conta: null,
					porcentagem: null
				};

				if(splitData.credito === null && splitData.em_conta === null){
					const resSplit = await apiPGM.get(
						'split',
						{
							headers: {
								'Content-Type': 'application/json',
								'Authorization': `Bearer ${user.token.access}`,
							},
						}
					);

					setSplitData(resSplit.data)

					splitporcentagem.credito = resSplit.data.credito;
					splitporcentagem.em_conta = resSplit.data.em_conta;
					splitporcentagem.porcentagem = resSplit.data.porcentagem;
				}else{
					splitporcentagem.credito = splitData.credito;
					splitporcentagem.em_conta = splitData.em_conta;
					splitporcentagem.porcentagem = splitData.porcentagem;
				}



				setRecebimentosCard({
					split: {
						nome_split: res.data.nome_split,
						parent: res.data.parent,
						nome_lojista_pai: res.data.nome_lojista_pai,
						porcentagem: splitporcentagem.porcentagem,
						credito: splitporcentagem.credito,
						em_conta: splitporcentagem.em_conta,
					},
					lista: arrayLista,
					loading: false,
					error: null,
				});
			} catch (error) {
				let info = 'Dados de recebimentos não foram carregados. Por favor atualize a página'
				if(error?.response?.data?.error){
					info = error?.response?.data?.error;
				}
				if(error?.response?.data?.message){
					info = error.response.data.message;
				}
				
				console.log(info)
			} finally {
				callingSplit = false;
				setLoadingRecebimentos(false);
			}
		},
		[tokenState]
	);

	const getRecebimentosGrupo = useCallback(
		async (dadosLojistaProp, tokenValue, paramsProp, pagina, idTitular) => {
			if (tokenState !== '') {
				tokenValue = tokenState;
			}
			try {
				setLoadingRecebimentos(true);

				const res = await apiTransacao.get(
					`recebimentos-group/${dadosLojistaProp}/${idTitular}?init_date=${paramsProp.dateInit}&end_date=${paramsProp.dateEnd}&page=${pagina}`,
					{
						headers: {
							'Content-Type': 'application/json',
							Authorization: tokenValue,
						},
					}
				);
				setTotalGrupos({
					total_bruto: 0,
					total_descontos: 0,
					total_debito: 0,
					total_credito: 0,
					total_parcelado: 0,
					total_liquido: 0,
					total_ajustes: 0,
				});

				const arrayLista = [];
				const arrayListaConcatenadaGrupo = [];
				const arrayListaConcatenadaGrupoConcatenadaParcelas = [];
				const arrayListaGrupoDownload = [];
				var cont = 0;

				Object.keys(res.data).forEach((item) => {
					if (parseInt(item, 10) === parseInt(idTitular, 10)) {
						// Concatenando Parcelas
						for (let i = 0; i < res.data[item].data.length; i++) {
							const arrayAdd = res.data[item].data[i];

							if (
								res.data[item].data[i].qtd_parcelas === 1 ||
								res.data[item].data[i].qtd_parcelas === null
							) {
								arrayListaConcatenadaGrupoConcatenadaParcelas.push(
									arrayAdd
								);
								// eslint-disable-next-line no-continue
								continue;
							}

							arrayAdd.valor_liquido =
								Math.round(
									(arrayAdd.valor_liquido +
										res.data[item].data[i + 1]
											.valor_liquido *
										(arrayAdd.qtd_parcelas - 1)) *
									100
								) / 100;
							arrayAdd.valor_desconto =
								Math.round(
									(arrayAdd.valor_desconto +
										res.data[item].data[i + 1]
											.valor_desconto *
										(arrayAdd.qtd_parcelas - 1)) *
									100
								) / 100;

							arrayListaConcatenadaGrupoConcatenadaParcelas.push(
								arrayAdd
							);

							i += arrayAdd.qtd_parcelas - 1;
						}

						// Concatenando Pages
						arrayListaConcatenadaGrupoConcatenadaParcelas.map(
							// eslint-disable-next-line array-callback-return
							(itemMap) => {
								arrayListaGrupoDownload.push(itemMap);
								const index = parseInt(cont / 10, 10);
								if (
									arrayListaConcatenadaGrupo.length - 1 <
									index
								) {
									arrayListaConcatenadaGrupo.push([]);
								}
								arrayListaConcatenadaGrupo[index].push(itemMap);
								cont++;
							}
						);
						// Valores para Cards
						setTotalGrupos({
							total_bruto: res.data[item].total_bruto,
							total_descontos: res.data[item].total_desconto,
							total_debito: res.data[item].total_bruto_debito,
							total_credito: res.data[item].total_bruto_credito,
							total_parcelado:
								res.data[item].total_bruto_parcelado,
							total_liquido: res.data[item].total_liquido,
							total_ajustes: res.data[item].total_ajustes || 0,
						});
					}

					arrayLista.push(res.data[item]);
				});

				setRecebimentosGrupo({
					data: res.data,
					lista: arrayLista,
					listaConcatenadaGrupo: arrayListaConcatenadaGrupo,
					listaGrupoDownload: arrayListaGrupoDownload,
					loading: false,
					error: null,
				});
			} catch (error) {
				// getRecebimentosGeral(tokenValue, params, pagina)
				// eslint-disable-next-line no-console
				console.error(
					'Dados de recebimentos de grupos não foram carregados. Por favor atualize a página'
				);
			} finally {
				setLoadingRecebimentos(false);
			}
		},
		[tokenState, user.dados.lojista_id]
	);

	const getRecebimentosGeral = useCallback(
		async (tokenValue, paramsProp, pagina, documentoTitular, filtroTipo, filtroRevendaHierarquia = '') => {
			if (tokenState) {
				tokenValue = tokenState;
			}
			try {
				setLoadingRecebimentos(true);

				var concat = '';
				var filtroTitular = '';
				var tipo_cupom = '';

				user.dados.tipo_cliente === 'simples' ||
					user.dados.tipo_cliente === 'split'
					? (concat = '/concat')
					: (concat = '');

				((filtroTipo && filtroTipo === '') && (tipo_cupom = ''));
				((filtroTipo && filtroTipo === 'todos') && (tipo_cupom = ''));
				((filtroTipo && parseInt(filtroTipo) === 0) && (tipo_cupom = '&tipo_cupom=0'));
				((filtroTipo && parseInt(filtroTipo) === 1) && (tipo_cupom = '&tipo_cupom=1'));



				(documentoTitular && documentoTitular !== '' && documentoTitular !== 'todos') && (filtroTitular = `&${user.dados.cargo.toLowerCase() === 'industria' ? 'distribuidor_documento' : 'split_cliente'}=${documentoTitular}`)

				if(documentoTitular === '' && filtroRevendaHierarquia && filtroRevendaHierarquia !== ''){
					filtroTitular = `&${user.dados.cargo.toLowerCase() === 'industria' ? 'distribuidor_documento' : 'split_cliente'}=${filtroRevendaHierarquia}`
				}

				const res = await apiTransacao.get(
					`recebimentos-cliente/${user.dados.user_id}${concat}?init_date=${paramsProp.dateInit}&end_date=${paramsProp.dateEnd}&page=${pagina}${filtroTitular}${tipo_cupom}`,
					{
						headers: {
							'Content-Type': 'application/json',
							Authorization: tokenValue,
						},
					}
				);

				const arrayLista = [];
				if (res.data.total_registros > 0) {
					Object.keys(res.data.recebimentos).forEach((item) => {
						arrayLista.push(res.data.recebimentos[item]);
					});
				}
				setRecebimentosGeral({
					dados: res.data,
					lista: arrayLista,
					loading: false,
					error: null,
				});

				// getRecebimentosDownload(tokenValue, params, pagina);
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(
					'Dados gerais de recebimentos não foram carregados. Por favor atualize a página'
				);
			} finally {
				setLoadingRecebimentos(false);
			}
		},
		[tokenState, user.dados.tipo_cliente, user.dados.user_id]
	);

	const getRecebimentosDashboard = useCallback(
		async (tokenValue, paramsProp, pagina, documentoTitular, filtroTipo, filtroRevendaHierarquia = '') => {
			if (tokenState) {
				tokenValue = tokenState;
			}

			if(paramsProp.dateInit !== "00-01-00" && paramsProp.dateEnd !== "00-01-00"){
				try {
					setLoadingRecebimentos(true);

					var concat = '';
					var filtroTitular = '';
					var tipo_cupom = '';

					user.dados.tipo_cliente === 'simples' ||
						user.dados.tipo_cliente === 'split'
						? (concat = '/concat')
						: (concat = '');

					((filtroTipo && filtroTipo === '') && (tipo_cupom = ''));
					((filtroTipo && filtroTipo === 'todos') && (tipo_cupom = ''));
					((filtroTipo && parseInt(filtroTipo) === 0) && (tipo_cupom = '&tipo_cupom=0'));
					((filtroTipo && parseInt(filtroTipo) === 1) && (tipo_cupom = '&tipo_cupom=1'));



					(documentoTitular && documentoTitular !== '' && documentoTitular !== 'todos') && (filtroTitular = `&split_cliente=${documentoTitular}`)

					if(documentoTitular === '' && filtroRevendaHierarquia && filtroRevendaHierarquia !== ''){
						filtroTitular = `&${user.dados.cargo.toLowerCase() === 'industria' ? 'distribuidor_documento' : 'split_cliente'}=${filtroRevendaHierarquia}`
					}

					const res = await apiTransacao.get(
						`recebimentos-cliente/${user.dados.user_id}${concat}?init_date=${paramsProp.dateInit}&end_date=${paramsProp.dateEnd}&items=1000&page=${pagina}${filtroTitular}${tipo_cupom}`,
						{
							headers: {
								'Content-Type': 'application/json',
								Authorization: tokenValue,
							},
						}
					);

					const arrayLista = [];
					if (res.data.total_registros > 0) {
						Object.keys(res.data.recebimentos).forEach((item) => {
							arrayLista.push(res.data.recebimentos[item]);
						});
					}
					return res.data;
					// getRecebimentosDownload(tokenValue, params, pagina);
				} catch (error) {
					// eslint-disable-next-line no-console
					console.log(
						'Dados gerais de recebimentos não foram carregados. Por favor atualize a página'
					);
					return error;
				} finally {
					setLoadingRecebimentos(false);
				}
			}

		},
		[tokenState, user.dados.tipo_cliente, user.dados.user_id]
	);

	const getAllRecebimentosGrupoConcatenado = useCallback(
		async (
			tokenValue,
			paramsProp,
			pagina,
			dadosLojistaProp,
			// eslint-disable-next-line no-unused-vars
			idTitular
		) => {
			if (tokenState !== '') {
				tokenValue = tokenState;
			}
			try {
				setLoadingRecebimentos(true);

				const res = await apiTransacao.get(
					`recebimentos-group-concat/${dadosLojistaProp}/${user.dados.lojista_id}?init_date=${paramsProp.dateInit}&end_date=${paramsProp.dateEnd}&page=${pagina}`,
					{
						headers: {
							'Content-Type': 'application/json',
							Authorization: tokenValue,
						},
					}
				);
				const arrayLista = [];
				const arrayListaConcatenadaGrupo = [];
				const arrayListaGrupoDownload = [];
				var cont = 0;

				setTotalGrupos({
					total_bruto: 0,
					total_descontos: 0,
					total_debito: 0,
					total_credito: 0,
					total_parcelado: 0,
					total_liquido: 0,
					total_ajustes: 0,
				});
				if (res.data.data.length > 0) {
					arrayLista.push(res.data.data[0]);

					// Concatenando Parcelas
					const arrayListaConcatenadaGrupoConcatenadaParcelas = res.data.data[0].map((arrayAdd, i) => {
						if (arrayAdd.qtd_parcelas === 1 || arrayAdd.qtd_parcelas === null) {
							return arrayAdd;
						}

						let somaValorLiquido = arrayAdd.valor_liquido;
						let somaValorDesconto = arrayAdd.valor_desconto;

						// for (let j = 1; j < arrayAdd.qtd_parcelas; j++) {
						//   if (i + j < res.data.data[0].length) {
						//     somaValorLiquido += res.data.data[0][i + j].valor_liquido;
						//     somaValorDesconto += res.data.data[0][i + j].valor_desconto;
						//   }
						// }

						arrayAdd.valor_liquido = Math.round(somaValorLiquido * 100) / 100;
						arrayAdd.valor_desconto = Math.round(somaValorDesconto * 100) / 100;

						return arrayAdd;
					}).filter(Boolean);

					// Concatenando Pages
					arrayListaConcatenadaGrupoConcatenadaParcelas.forEach(itemMap => {
						arrayListaGrupoDownload.push(itemMap);
						const index = Math.floor(cont / 10);
						if (arrayListaConcatenadaGrupo.length - 1 < index) {
							arrayListaConcatenadaGrupo.push([]);
						}
						arrayListaConcatenadaGrupo[index].push(itemMap);
						cont++;
					});
				}

				// Valores para Cards
				setTotalGrupos({
					total_bruto: res.data.total_bruto  || 0,
					total_descontos: res.data.total_desconto  || 0,
					total_debito: res.data.total_debito  || 0,
					total_credito: res.data.total_credito  || 0,
					total_parcelado: res.data.total_parcelado  || 0,
					total_liquido: res.data.total_liquido  || 0,
					total_ajustes: res.data.total_ajustes || 0,
				});

				setRecebimentosGrupo({
					data: '',
					lista: arrayLista,
					listaConcatenadaGrupo: arrayListaConcatenadaGrupo,
					listaGrupoDownload: '',
					loading: false,
					error: null,
				});


			} catch (error) {
				// getRecebimentosGeral(tokenValue, params, pagina)
				// eslint-disable-next-line no-console
				console.error(
					'Dados de recebimentos de grupos não foram carregados. Por favor atualize a página'
				);
			} finally {
				setLoadingRecebimentos(false);
			}
		},
		[tokenState, user.dados.lojista_id]
	);

	const getRecebimentosGrupoAuthentication = useCallback(
		async (token, paramsProps, page, resLojista, idTitular, documentoTitular, filtroTipo, filtroRevendaHierarquia = '') => {
			// Alimentando Select
			if ((user.dados.cargo.toLowerCase() === 'industria' && user.dados.tipo_projeto.toLowerCase() === 'intelbras') || (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.tipo_projeto.toLowerCase() === 'iquine')) {
				getLojistasGrupo(token, resLojista?.[0].grupo_nome);
			}

			if (user.dados.tipo_cliente === 'grupo') {
				getLojistasGrupo(token, resLojista?.[0].grupo_nome);

				if (idTitular !== 'todos') {
					getRecebimentosGrupo(
						resLojista?.[0].grupo_nome,
						token,
						paramsProps,
						page,
						idTitular
					);
				} else {
					getAllRecebimentosGrupoConcatenado(
						token,
						paramsProps,
						page,
						resLojista?.[0].grupo_nome,
						idTitular
					);
				}
			} else if (
				user.dados.tipo_cliente === 'simples' ||
				user.dados.tipo_cliente === 'split'
			) {
				getRecebimentosGeral(token, paramsProps, page, documentoTitular, filtroTipo, filtroRevendaHierarquia);
			}
		},
		[
			getAllRecebimentosGrupoConcatenado,
			getRecebimentosGeral,
			getRecebimentosGrupo,
			user.dados.tipo_cliente,
		]
	);

	const authenticationGroup = useCallback(
		async (paramsProp, page, idTitular, documentoTitular, filtroTipo, filtroRevendaHierarquia = '') => {
			try {
				const tokenResponse = await authToken();

				setTokenState(tokenResponse);
				if (user.dados.tipo_cliente === 'grupo' || (user.dados.cargo.toLowerCase() === 'industria' && user.dados.tipo_projeto.toLowerCase() === 'intelbras') || (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.tipo_projeto.toLowerCase() === 'iquine')) {
					getLojista(tokenResponse).then((resLojista) => {
						getRecebimentosCard(
							tokenResponse,
							user.dados.user_id
							// idTitular === 'todos'
							// 	? user.dados.user_id
							// 	: idTitular
						);
						getRecebimentosGrupoAuthentication(
							tokenResponse,
							paramsProp,
							page,
							resLojista,
							idTitular,
							documentoTitular,
							filtroTipo,
							filtroRevendaHierarquia
						);
					});
				} else {
					getRecebimentosCard(tokenResponse, user.dados.user_id);
					getRecebimentosGrupoAuthentication(
						tokenResponse,
						paramsProp,
						page,
						'',
						idTitular,
						documentoTitular,
						filtroTipo,
						filtroRevendaHierarquia
					);
				}
			} catch (error) {
				toast.error('Alguns dados não foram carregados.');
			}
		},
		[
			getLojista,
			getRecebimentosCard,
			getRecebimentosGrupoAuthentication,
			user.dados.tipo_cliente,
			user.dados.user_id,
		]
	);


	async function authToken() {
		let result = null;
		try {
			result = await autenticacaoV1Token();
		} catch (e) {
			console.error(e);
		}
		return result;
	}

	/**
	 * Download EXCEL
	 */

	function download(data) {
		var oReq = new XMLHttpRequest();
		oReq.open(
			'POST',
			'https://api.grupoe2f.com.br/export/export',
			true
		);
		oReq.responseType = 'blob';
		oReq.setRequestHeader('Content-Type', 'application/json');

		const link = document.createElement('a');

		oReq.onload = function () {
			var blob = oReq.response;
			link.setAttribute('download', 'recebimentosLucree.xlsx');
			link.href = URL.createObjectURL(blob);
			// window.location.href = link.href
			link.setAttribute('href', URL.createObjectURL(blob));
			document.body.appendChild(link);
			link.click();

			setLoaderRecebimentos(false);
		};

		oReq.send(JSON.stringify(data));
	}

	const getExport = useCallback(
		async (user_id, token, paramsProp, documentoTitular, filtroTipo, filtroRevendaHierarquia = '') => {
			try {
				let data_path = '';
				let url = '';

				var filtroTitular = '';

				var concat = '';
				var tipo_cupom = '';

				var paramsInfo =  {
					items: 30000,
					init_date: paramsProp.dateInit,
					end_date: paramsProp.dateEnd,
				};

				((filtroTipo && filtroTipo === '') && (tipo_cupom = ''));
				((filtroTipo && filtroTipo === 'todos') && (tipo_cupom = ''));
				((filtroTipo && parseInt(filtroTipo) === 0) && (tipo_cupom = '?tipo_cupom=0'));
				((filtroTipo && parseInt(filtroTipo) === 1) && (tipo_cupom = '?tipo_cupom=1'));

				if(documentoTitular === '' && filtroRevendaHierarquia && filtroRevendaHierarquia !== ''){
					if(user.dados.cargo.toLowerCase() === 'industria'){
						paramsInfo.distribuidor_documento = filtroRevendaHierarquia
					}else {
						paramsInfo.split_cliente = filtroRevendaHierarquia
					}
				}

				user.dados.tipo_cliente === 'simples' ||
					user.dados.tipo_cliente === 'split'
					? (concat = '/concat')
					: (concat = '');

				(documentoTitular && documentoTitular !== '' && documentoTitular !== 'todos') && (filtroTitular = `?${user.dados.cargo.toLowerCase() === 'industria' ? 'distribuidor_documento' : 'split_cliente'}=${documentoTitular}`)

				// Condicional Url
				user.dados.tipo_cliente === 'grupo'
					? (url = `https://api-transacoesdash.lucree.com.br/recebimentos-group${user_id === 'todos' ? '-concat' : ''}/${dadosLojista}/${user.dados.lojista_id}`)
					: (filtroTitular === ''
						? url = `https://api-transacoesdash.lucree.com.br/recebimentos-cliente/${user_id}/concat${tipo_cupom}`
						: url = `https://api-transacoesdash.lucree.com.br/recebimentos-cliente/${user_id}${concat}${filtroTitular}`);

				// Condicional data_path
				user.dados.tipo_cliente === 'grupo'
					? (data_path =
						user_id === 'todos'
							? `.data.0`
							: `.${user_id.toString()}.data`)
					: (data_path = '.recebimentos');

				let perfil = null


				if(projetos.includes(user.dados.tipo_projeto)){
					perfil = PerfilQD[user.dados.tipo_cliente]
				}else if(user.dados.cargo.toLowerCase() === 'industria'){
					perfil = TipoPerfil['split_industria']
				}else{
					perfil = TipoPerfil[user.dados.tipo_cliente]
				}

				const payload = {
					logo: 'lucree',
					sheet_name: 'Planilha Lucree',
					request: {
						data_path: data_path,
						url: url,
						headers: {
							Authorization: token,
						},
						params: paramsInfo,
					},
					styles: [
						{
							name: 'data_br',
							num_format: "%d/%m/%y",
						},
					],
					format: perfil, // Acessando dicionário dentro do Json TipoPerfil
				};

				download(payload);
			} catch (error) {
				setLoaderRecebimentos(false);
				setLoadingRecebimentos(false);
				// eslint-disable-next-line no-console
				console.log('Erro no Download Export, recebimentos.');
			}
		},
		[dadosLojista, user.dados.lojista_id, user.dados.tipo_cliente]
	);

	async function getLojistasGrupo(tokenValue, grupoNome) {
		try {
			const arrayConcatenarGrupo = [];

			await apiGrupos.get(`/api/grupos/${grupoNome}`, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': tokenValue
				}
			}).then(res => {
				const { tree } = res.data.data;
				const { root } = res.data.data;
				// Titular (Pai)
				arrayConcatenarGrupo.push({
					id: root,
					grupo: tree[root].sub
				})
				Object.entries(tree[root].children).map((key, item) => {
					// Filhos
					arrayConcatenarGrupo.push({
						id: key[0],
						grupo: key[1].sub
					})
				})

				// Retirando Tinta Iquine da lista
				const arrayConcatenarGrupoOrdenado = arrayConcatenarGrupo.sort(function (a, b) {
					if (a.id !== "17157") {
						return a.grupo.nome < b.grupo.nome ? -1 : a.grupo.nome > b.grupo.nome ? 1 : 0;
					}
				});
				arrayConcatenarGrupoOrdenado.shift()
				//

				setGruposTitularConcatenado(arrayConcatenarGrupoOrdenado)
			})


		} catch (error) {
			console.log('Os dados do lojista grupo não foram carregados.', error);
		}
	}

	useEffect(() => {
		setLoadingRecebimentos(true);
		authenticationGroup(params, 1, user.dados.lojista_id, documentoTitular, filtroTipo);
	}, []);

	const contextValue = useMemo(
		() => ({
			filtroTipo,
			setFiltroTipo,
			documentoTitular,
			setDocumentoTitular,
			recebimentosCard,
			recebimentosGeral,
			recebimentosGrupo,
			getRecebimentosGrupoAuthentication,
			getRecebimentosGeral,
			getRecebimentosDashboard,
			authenticationGroup,
			loadingRecebimentos,
			setLoadingRecebimentos,
			setLoaderRecebimentos,
			loaderRecebimentos,
			totalGrupos,
			dadosLojista,
			gruposTitularConcatenado,
			getExport,
			authToken,
		}),
		[
			filtroTipo,
			setFiltroTipo,
			documentoTitular,
			setDocumentoTitular,
			authenticationGroup,
			dadosLojista,
			getExport,
			getRecebimentosGeral,
			getRecebimentosGrupoAuthentication,
			gruposTitularConcatenado,
			loaderRecebimentos,
			loadingRecebimentos,
			recebimentosCard,
			recebimentosGeral,
			recebimentosGrupo,
			totalGrupos,
		]
	);

	return (
		<RecebimentosContext.Provider value={contextValue}>
			{children}
		</RecebimentosContext.Provider>
	);
}
